import { CheckCircleIcon } from '@heroicons/react/solid';

export default function SubmitSuccess({
  message,
  confirmationNumber,
}: {
  message: string;
  confirmationNumber?: string;
}) {
  return (
    <div className='container mx-auto flex justify-center'>
      <div className='bg-white p-4 rounded-md w-1/2 flex flex-col justify-center items-center text-center gap-6 mb-10'>
        <div className='flex items-center gap-2 text-primaryColor-normal'>
          <CheckCircleIcon className='h-5 w-5' />
          <h2 className='m-0 '>Success</h2>
        </div>
        <h3>Your Application has been successfully submitted!</h3>
        <p>{message}</p>

        {confirmationNumber && <p>Confirmation Number: {confirmationNumber}</p>}
        <span>You can close your browser now.</span>
      </div>
    </div>
  );
}
